import React, { FC, useMemo } from 'react'
import { DetailsContactData } from '../types/detailsContactTypes'
import styles from '../../../styles'
import { makeStyles } from 'tss-react/mui'
import { Grid } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import InformationsDossierBail from './InformationsDossierBail'
import InformationsAcGl from './InformationsAcGl'
import { buttonSize } from '../../../components/button/enums/buttonEnum'
import Button from '../../../components/button/Button'
import links from '../../../enums/linksEnum'
import { useNavigate } from 'react-router'

interface InformationsContactProps {
	isClientType: boolean
	informations: DetailsContactData
}

const INFORMATION_PATH: string = 'detailsContact.informations'

const InformationsContact: FC<InformationsContactProps> = (
	{
		isClientType,
		informations
	}) => {
	const navigate = useNavigate()
	const { classes, cx } = useStyles()
	const typeContact: string = useMemo(() => isClientType ? 'client' : 'prospect', [isClientType])

	const descriptionStyle = cx(
		classes.text1,
		classes.descriptionStyle
	)

	return (
		<Grid container item flexDirection="column" spacing="40px">
			<Grid item className={descriptionStyle}>
				<FormattedMessage
					id={`${INFORMATION_PATH}.${typeContact}.description`}
					defaultMessage="Le contact est déjà client."
					description="Le contact est déjà client."
					values={{ br: <br /> }}
				/>
			</Grid>
			{((isClientType && !!informations.bail) || (!isClientType && !!informations.dossier)) && (
				<InformationsDossierBail
					informations={informations}
					typeContact={typeContact}
					isClientType={isClientType}
				/>
			)}
			<Grid item className={descriptionStyle}>
				<FormattedMessage
					id={`${INFORMATION_PATH}.${typeContact}.invite`}
					defaultMessage="Invitez-le à accéder à son espace client et à utiliser la fonctionnalité de changement d'appartement / parking ou communiquez-lui les coordonnées suivantes du Gestionnaire Locatif."
					description="Invitez-le à accéder à son espace client et à utiliser la fonctionnalité de changement d'appartement / parking ou communiquez-lui les coordonnées suivantes du Gestionnaire Locatif."
				/>
			</Grid>

			<InformationsAcGl contact={isClientType ? informations.gl : informations.ac} />

			<Grid container item>
				<Button
					background="backgroundAccessibility"
					color="colorWhite"
					textStyle="text4"
					size={buttonSize.small}
					// Retour à la page de recherche
					onClick={() => navigate(links.RECHERCHE_CONTACT)}
					buttonStyle={classes.buttonStyle}
					fullWidth
				>
					<FormattedMessage
						id="detailsContact.back"
						defaultMessage="Retour à la liste des contacts"
						description="Bouton pour retourner sur la recherche de contact"
					/>
				</Button>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	descriptionStyle: {
		lineHeight: '32px'
	},
	buttonStyle: {
		borderRadius: 25,
		maxWidth: 294
	}
}))

export default InformationsContact